<img class="logo" [src]="logoSrc" alt="Company Logo" />
